<template>
  <div class="plan column box__shadow highlight__extra">
    <div class="plan__header row">
      <div class="icon row center">
        <i :class="plan.icon"></i>
      </div>

      <h4 class="row">{{ plan.name }}</h4>
    </div>

    <p class="description">{{ t(plan.description) }}</p>

    <div class="pricing row">
      <span>€{{ plan.price[interval] }}</span>
      <span>/ {{ t(interval === 'monthly' ? 'Month' : 'Year') }}</span>
    </div>

    <div class="line"></div>

    <ul>
      <li v-for="f in plan.features" :key="f" class="feature row">
        <i class="fa-solid fa-check"></i>

        <div class="column">
          <p class="feature__name">{{ t(f.name, f.value) }}</p>
          <span v-if="f.description" class="feature__description">{{ t(f.description) }}</span>
        </div>
      </li>
    </ul>

    <p v-if="plan.button === 'register'" class="reset">{{ t('plan_reset') }}</p>

    <a
      v-if="plan.button === 'register'"
      :href="`https://app.arcticreply.com/auth/register?language=${$store.state.language}&campaign=${$store.state.campaign}`"
      target="_blank"
      rel="noopener noreferrer"
    >
      {{ t('pricing_btn') }}
    </a>

    <a v-else href="mailto:info@arcticreply.com" class="contact_btn">
      <span>{{ t('Contact us') }}</span>
    </a>
  </div>
</template>

<script>
export default {
  name: 'Plan',
  props: {
    plan: { type: Object, default: {} },
    interval: { type: String, default: 'monthly' },
  },
}
</script>

<style lang="scss" scoped>
.plan {
  padding: 30px;
  border-radius: 15px;
  width: 260px;
  max-width: 100%;
  margin: 5px;
  height: 1050px;

  @media (max-width: 599px) {
    height: auto;
  }

  .plan__header {
    .icon {
      width: 65px;
      height: 65px;
      border-radius: 15px;
      background-color: var(--arctic-5);
      margin: 0 20px 0 0;

      i {
        font-size: 2rem;
      }
    }

    h4 {
      height: 65px;
      width: calc(100% - 75px);
      font-size: 1.25rem;
      margin: 0;
      align-items: center;
    }
  }

  .description,
  .reset {
    color: var(--dark-6);
    font-size: 0.9rem;
    line-height: 20px;
    margin-bottom: 5px;
  }

  .reset {
    text-align: center;
    margin-top: auto;
  }

  .pricing {
    font-size: 1.15rem;
    align-items: flex-end;

    span {
      &:first-of-type {
        font-size: 2.5rem;
        margin-right: 5px;
        letter-spacing: -2px;
      }

      &:last-of-type {
        font-size: 0.9rem;
        margin-bottom: 15px;
      }
    }
  }

  .line {
    border-bottom: 2px solid var(--arctic);
    width: 100%;
    margin: 10px auto 20px auto;
  }

  ul {
    margin: 0px;
    padding: 0;

    li {
      list-style: none;
      margin: 0 0 15px 0;
      display: flex;

      i {
        margin: 3px 15px 0 0;
        color: var(--valid);
        font-size: 1.35rem;
      }

      p {
        margin: 0;
        font-size: 0.9rem;
      }

      span {
        color: var(--dark-6);
        font-size: 0.8rem;
        line-height: 20px;
      }
    }
  }

  a {
    margin: 20px auto 0 auto;
    padding: 10px 50px;
    background-color: var(--dark-10);
    color: var(--base);
    border-radius: 25px;

    &:hover,
    &:active {
      transform: scale(0.98);
    }

    &.contact_btn {
      margin-top: auto;
    }
  }
}
</style>
